import { render } from "./NodeHeadline.vue?vue&type=template&id=5549e896&scoped=true"
import script from "./NodeHeadline.vue?vue&type=script&lang=js"
export * from "./NodeHeadline.vue?vue&type=script&lang=js"

import "./NodeHeadline.vue?vue&type=style&index=0&id=5549e896&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5549e896"]])

export default __exports__